export default __webpack_public_path__ + "static/media/leaflet-marker-yellow.e3283676.svg";